module.exports = __webpack_public_path__ + "static/media/btn_tiger.57bfb7a9.png";